export enum PATHS {
  home = "",
  settings = "settings",
  project = "project",
  create_new_project = "create",
  data = "data",
  admin = "admin",
  oauthCallback = "oauth-callback",
  useCases = "use-cases",
}

export enum PROJECT_PATHS_HIDE_EDITVIDEO {
  overview = "overview",
  analytics = "analytics",
  customAnalytics = "analytics-custom",
  liveControl = "live-control",
  settings = "settings",
  editContent = "edit-content",
  integration = "integration",
  formData = "form-data",
  // social = "social",
  // DataAutomation = "data-automation",
  // Tutorials = "tutorials",
}
export enum PROJECT_PATHS {
  overview = "overview",
  analytics = "analytics",
  customAnalytics = "analytics-custom",
  liveControl = "live-control",
  settings = "settings",
  editContent = "edit-content",
  integration = "integration",
  formData = "form-data",
  optimization = "optimization",
  flowMap = "flow-map",
  deepAnalytics = "deep-analytics"
  // social = "social",
  // DataAutomation = "data-automation",
  // Tutorials = "tutorials",
}

export const toPath = (...paths: string[]) => {
  return [""].concat(...paths).join("/");
};
export const pathToPieces = (path: string): string[] => {
  return path.split("/");
};

export const camelCaseToRegular = (str: string) => {
  if (str === "MP5AI") return "MP5 AI";
  return str.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
    return str.toUpperCase();
  });
};
